import React, { useMemo } from "react";
import { Container, Graphics } from "@pixi/react";
import { useSelector, useDispatch } from "react-redux";
import { usePrimaryUIToolbarDimensionsV2 } from "../../../../Hooks/usePrimaryUIToolbarDimensionsV2";
import { useDimensions } from "../../../../Contexts/DimensionsContext";
import { USER_INTERFACE_BUTTON_CONFIG } from "../../../../textureConfigs";
import { PixiSettings } from "../../../../pixiSettings";

import ButtonHome from "../Buttons/ButtonHome";
import ButtonBuyBonus from "../Buttons/ButtonBuyBonus";
import ButtonFullscreen from "../Buttons/ButtonFullscreen";
import Clock from "../Other/Clock";
import { selectMenuActive } from "../../../../State/selectors";
import { closeMenu } from "../../../../State/actions";
import { FEATURES_CONFIG } from "../../../../featuresConfig";



// Top toolbar height multipliers per device/orientation (same structure as usePrimaryUIToolbarDimensionsV2)
const TOOLBAR_TOP_HEIGHT_CONFIG = {
  [PixiSettings.DEVICE.MOBILE]: {
    [PixiSettings.ORIENTATION.PORTRAIT]: 1.0,
    [PixiSettings.ORIENTATION.LANDSCAPE]: 1.0,
  },
  [PixiSettings.DEVICE.TABLET]: {
    [PixiSettings.ORIENTATION.PORTRAIT]: 1.0,
    [PixiSettings.ORIENTATION.LANDSCAPE]: 1.0,
  },
  [PixiSettings.DEVICE.DESKTOP]: 1.0,
};

const ToolbarTop = () => {
  const toolbar = usePrimaryUIToolbarDimensionsV2();
  const { dimensions, device, orientation, getResponsiveConfig } =
    useDimensions();
  const menuActive = useSelector(selectMenuActive);
  const dispatch = useDispatch();

  const buttonConfig = useMemo(
    () => getResponsiveConfig(USER_INTERFACE_BUTTON_CONFIG, true),
    [getResponsiveConfig],
  );

  const topToolbar = useMemo(() => {
    const heightMultiplier =
      device === PixiSettings.DEVICE.DESKTOP
        ? TOOLBAR_TOP_HEIGHT_CONFIG[device]
        : (TOOLBAR_TOP_HEIGHT_CONFIG[device]?.[orientation] ?? 0.9);
    return {
      width: toolbar.width,
      height: buttonConfig.height * heightMultiplier,
    };
  }, [toolbar.width, device, orientation, buttonConfig.height]);

  const handleClickOutside = () => {
    dispatch(closeMenu());
  };

  return (
    <Container
      name="secondary_toolbar_top"
      x={(dimensions.width - topToolbar.width) / 2}
      sortableChildren={true}
      y={0}
      zIndex={10}
    >
      {/* Background is rendered by ToolbarBackgrounds (behind game layer) */}

      {/* Invisible clickable background when menu is active - closes menu when clicked */}
      {menuActive && (
        <Graphics
          name="menu_click_outside"
          zIndex={0}
          draw={(g) => {
            g.clear();
            g.beginFill(0x000000, 0.001); // Nearly transparent but still interactive
            g.drawRect(
              -(dimensions.width - topToolbar.width) / 2,
              0,
              dimensions.width,
              dimensions.height,
            );
            g.endFill();
          }}
          eventMode="static"
          onpointertap={handleClickOutside}
        />
      )}

      <ButtonHome toolbar={topToolbar} />
      {FEATURES_CONFIG.BONUS_BUY.ENABLED && <ButtonBuyBonus toolbar={topToolbar} />}
      <Clock toolbar={topToolbar} />


      <ButtonFullscreen toolbar={topToolbar} />
    </Container>
  );
};

export default ToolbarTop;
